import { render, staticRenderFns } from "./ProjectSttSettingsView.vue?vue&type=template&id=66529fdc&scoped=true&"
import script from "./ProjectSttSettingsView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProjectSttSettingsView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProjectSttSettingsView.vue?vue&type=style&index=0&id=66529fdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66529fdc",
  null
  
)

export default component.exports